<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-2">
          <div class="selection-options" v-if="items.length">
            <multiselect v-model="selectedCompany" :options="companies" :disabled="companies.length < 2"
              :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select_company')"
              label="companyName" track-by="companyId"></multiselect>

            <br />

            <multiselect v-model="selectedCustomers" :options="customers" :disabled="!selectedCompany"
              :selectLabel="$t('press_enter_to_select')" :multiple="true" :placeholder="$t('select_customers')"
              :close-on-select="false" :clear-on-select="false" :hide-selected="true" :preserve-search="true"
              :preselect-first="false" :optionsLimit="2000" label="customerName" track-by="customerId"></multiselect>
          </div>

          <div class="selection-options" v-if="!items.length && !loading">
            <h5>{{ $t("no_companies_associated_this_account") }}</h5>

            <br />

            <span>{{ $t("please_contact_your_contact_person") }}</span>
          </div>
        </div>

        <div class="col-md-2">
          <div class="continue" v-if="items.length">
            <b-button variant="outline-secondary" v-on:click="goToPortal()" :disabled="!selectedCustomers.length">{{
              $t('continue') }}</b-button>
          </div>
        </div>

        <b-modal id="license-expired" ref="modal" title="Licentie verlopen">
          <p class="my-2">{{ $t('your_license_has_expired') }}</p>
          <!-- <p>{{expiredSalesGroup.salesGroupId}}</p> -->

          <template v-slot:modal-footer="">
            <b-button @click="ok()">{{ $t('continue') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Selection',
  components: {},
  data: function () {
    return {
      items: [],
      companies: [],
      companyOptions: [],
      customers: [],
      selectedCustomers: [],
      selectedCompany: null,
      loading: true,
      expiredSalesGroup: {
        salesGroupId: ''
      },
      roleId: null,
    };
  },
  watch: {
    selectedCompany: function (val) {
      if (val == null) {
        return;
      }

      this.selectedCustomers = [];

      this.items.forEach(element => {
        if (element.company.companyId === val.companyId) {
          this.customers = element.customers;

          if (element.customers.length <= 1) {
            this.selectedCustomers = this.customers;

            goToPortal(this);
          }
        }
      });
    }
  },
  beforeCreate: function () {
    resetCookies(this);

    let promise = this.$axios.get('selection');

    return promise
      .then(data => {
        const items = data.data.selectionResults;
        const roleId = data.data.roleId;

        items.forEach(element => {
          this.companies.push(element.company);
        });

        this.items = items;
        this.roleId = roleId;
        this.loading = false;

        if (items.length <= 1) {
          if (items[0].customers.length <= 1) {
            this.selectedCompany = items[0].company;
            this.selectedCustomers = items[0].customers;

            goToPortal(this);
          }
        }

        if (this.companies.length === 1) {
          this.selectedCompany = this.companies[0];
        }
      })
      .catch(error => {
        console.log(error);

        this.loading = false;

        return [];
      });
  },
  methods: {
    goToPortal: function () {
      let allSelected = false;

      this.selectedCustomers.forEach(customer => {
        if (customer.customerId.indexOf('*ALL-') !== -1) {
          allSelected = true;
        }
      });

      if (allSelected) {
        this.selectedCustomers = this.customers;
      }

      goToPortal(this);
    },
    ok: function () {
      this.$cookie.set('licenseExpired', true, 1);

      this.$router.replace({ name: 'service-objects' });
    }
  }
};

function goToPortal(context) {
  context.$cookie.set('companyId', context.selectedCompany.companyId, 1);

  let companyAllSelected = false;
  let clientAllSelected = false;
  let customerIds = [];
  let customers = [];
  let expiredSalesGroups = [];

  context.selectedCustomers.forEach(customer => {
    if (customer.customerId.indexOf('*ALL-') !== -1) {
      companyAllSelected = true;
    } else if (customer.customerId.indexOf('clientAll') !== -1) {
      clientAllSelected = true;
    }
  });

  if (companyAllSelected) {
    customerIds.push('*ALL*');
  } else if (clientAllSelected) {
    context.customers.forEach(customer => {
      if (customer.customerId !== 'clientAll') {
        customerIds.push(customer.customerId);
        customers.push(customer);
      }
    });
  } else {
    context.selectedCustomers.forEach(customer => {
      customerIds.push(customer.customerId);
      customers.push(customer);
    });
  }

  // Check expired licences
  context.items.forEach(item => {
    if (item.company.companyId === context.selectedCompany.companyId) {
      if (item.salesGroupsWithAnExpiredLicense.length > 0) {
        item.salesGroupsWithAnExpiredLicense.forEach(sg => {
          customers.forEach(c => {
            if (c.salesGroupId === sg.salesGroupId) {
              expiredSalesGroups.push(sg);
            }
          });
        });
      }
    }
  });

  context.$cookie.set('selectedCustomers', JSON.stringify(customerIds), 1);

  if (expiredSalesGroups.length > 0) {
    context.expiredSalesGroup = expiredSalesGroups[0];
    context.$refs.modal.show();
  } else {
    context.$cookie.set('licenseExpired', false, 1);

    if (context.roleId !== 4) {
      context.$router.replace({name: 'service-objects'});
    } else {
      context.$router.replace({name: 'invoices'});
    }
  }
}

function resetCookies(context) {
  context.$cookie.delete('companyId');
  context.$cookie.delete('selectedCustomers');

  var gridIds = ['so', 'sc', 'ca', 'lo', 'li', 'sg', 'co', 'sc-so', 'so-ca'];
  gridIds.forEach(id => {
    context.$cookie.delete(id + '-filter');
    context.$cookie.delete(id + '-sortBy');
    context.$cookie.delete(id + '-sortDesc');
    context.$cookie.delete(id + '-currentPage');
  });
}
</script>

<style scoped>
.container {
  background-color: white;
}

.container-fluid {
  padding-left: 0;
  padding-right: 0;
}

.nav-item {
  margin-bottom: 16px;
}

.nav-item img {
  width: 300px;
  border: 1px solid white;
}

.nav-item img:hover {
  border: 1px solid lightgray;
  cursor: pointer;
}

.multiselect__option {
  background-color: red;
}

.custom__tag {
  padding: 2px;
  margin-right: 8px;
  border: 1px solid lightgray;
  background-color: lightgray;
  border-radius: 5px;
}

.custom__remove {
  margin-left: 5px;
  cursor: pointer;
}

.selection-options {
  margin-top: 32px;
}

.continue {
  margin-top: 64px;
}
</style>
